/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-11 18:21:22
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-24 13:56:57
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/Subscription/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { Input, TextArea } from 'src/components/Antd';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextOnlyContainer from 'src/components/DragRowDisplay/TextOnly';
import TCModals from 'src/constrains/TermsAndConditionsSelection';
// import FieldModal from 'src/components/FieldModal/Subscription';
import CountWords from '@/src/components/CountWords/CountWords';
import { get, uniq } from 'lodash';
import FieldContainer from 'src/components/DragRowDisplay/DoubleRowsTextAndEditIcon';
import FieldModal from 'src/components/FieldModal';
import { EnumFieldType } from 'src/components/FieldModal/config';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { Tag } from 'src/components/Tags/Tags';
import { errKeys } from 'src/constrains/DraggableModules/tools';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { EnumModuleType } from 'src/types/common/module';

const unDeletable = [EnumFieldType.Email];
const _errKeys = errKeys[EnumModuleType.Subscription];
const Subscription = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    staticData,
    onStaticChange,
    draggableId,
    tcsOptions,
    onItemDelete,
    onItemReselect,
    onItemSort,
    droppableId,
    onItemChange,
    onItemAdd,
    tacs = [],
    fields = [],
    specificError,
    fieldsOptions = [],
  } = props;

  const titleErr = specificError[_errKeys.subscriptionTitle] || [];
  const btnTitleErr = specificError[_errKeys.buttonTitle] || [];
  const tcErr = specificError[_errKeys.termsAndConditions] || [];
  const [tcVisible, setTcVisible] = React.useState(false);
  const [fieldsVisible, setFieldsVisible] = React.useState(false);
  const [selectedField, setSelectedField] = React.useState<any>({});

  const generateAvailableField = (currentField?) => {
    const currentOccupiedField = fields.map((i) => {
      return get(i, 'field.uuid');
    });
    const _currentOccupiedField = currentOccupiedField.filter(
      (i) => i !== currentField,
    );
    const ava = fieldsOptions.filter((i) => {
      const type = get(i, 'uuid');
      return !_currentOccupiedField.includes(type);
    }); // difference(types, _currentOccupiedField);
    return ava;
  };

  const onFieldModalCancel = () => {
    setFieldsVisible(false);
    setSelectedField({});
  };
  const { title, description, buttonStyle, backgroundColor, textColor } =
    staticData;

  const {
    text,
    backgroundColor: btnBkgColor,
    textColor: btnTextColor,
  } = buttonStyle;

  const handleOnTitleChange = (title) => {
    if (onStaticChange) {
      onStaticChange({ title });
    }
  };
  const handleOnDesChange = (description) => {
    if (onStaticChange) {
      onStaticChange({ description });
    }
  };

  const handleOnBkgChange = (backgroundColor) => {
    if (onStaticChange) {
      onStaticChange({ backgroundColor });
    }
  };
  const handleOnTextColorChange = (textColor) => {
    if (onStaticChange) {
      onStaticChange({ textColor });
    }
  };
  const handleOnBtnTextChange = (text) => {
    if (onStaticChange) {
      onStaticChange({
        buttonStyle: {
          text,
          backgroundColor: btnBkgColor,
          textColor: btnTextColor,
        },
      });
    }
  };
  const handleOnBtnBkgColorChange = (backgroundColor) => {
    if (onStaticChange) {
      onStaticChange({
        buttonStyle: {
          text,
          backgroundColor,
          textColor: btnTextColor,
        },
      });
    }
  };
  const handleOnBtnTextColorChange = (textColor) => {
    if (onStaticChange) {
      onStaticChange({
        buttonStyle: {
          text,
          backgroundColor: btnBkgColor,
          textColor,
        },
      });
    }
  };
  const handleOnTCReselect = (tc) => {
    // console.log(tc, 'tcs');
    const _tc = tc.map((i) => {
      const { uuid } = i;
      return { ...i, draggableId: uuid };
    });
    onItemReselect(_tc, 'tacs');
  };

  const handleOnTCDelete = (index) => {
    onItemDelete(index, 'tacs');
  };

  const handleOnTCSort = (sort) => {
    const { newIndex, oldIndex } = sort.data;
    onItemSort(oldIndex, newIndex, 'tacs');
  };

  const tcChildGenerate = (data, index) => {
    const { name } = data;
    return <TextOnlyContainer name={name} />;
  };

  const handleOnFieldDelete = (index) => {
    onItemDelete(index, 'fields');
  };

  const handleOnFieldSort = (sort) => {
    const { newIndex, oldIndex } = sort.data;

    onItemSort(oldIndex, newIndex, 'fields');
  };

  const handleOnFieldAdd = (field) => {
    onItemAdd([field], 'fields');
  };

  const handleOnFieldEdit = (index, field) => {
    onItemChange(index, field, 'fields');
  };

  const handleOnFieldOk = (field) => {
    const {
      draggableId,
      field: _field,
      required,
      dateOfBirthFields,
      isAddNew,
      index,
      placeholder,
    } = field;
    const currentField = get(_field, 'uuid');
    const _draggableId = draggableId || currentField;

    const obj = {
      draggableId: _draggableId,
      field: _field,
      required,
      dateOfBirthFields,
      placeholder,
    };
    if (isAddNew) {
      handleOnFieldAdd(obj);
    } else {
      handleOnFieldEdit(index, obj);
    }
    onFieldModalCancel();
  };

  const fieldChildGenerate = (data, index) => {
    const { field, required, dateOfBirthFields } = data;
    //
    const currentField = get(field, 'fieldType');
    const currentUuid = get(field, 'uuid');
    const name = get(data, 'placeholder');
    const fieldName = get(field, 'name');
    const ava = generateAvailableField(currentUuid);
    const className = unDeletable.includes(currentField)
      ? css.fieldContainer
      : '';
    return (
      <FieldContainer
        title={`${fieldName} ${required ? '(required field)' : ''}`}
        name={`${name} ${dateOfBirthFields || ''}`}
        containerClassName={className}
        onClick={() => {
          setSelectedField({ ...data, index, availableFields: ava });
          setFieldsVisible(true);
        }}
      />
    );
  };

  const getAllAttributes = () => {
    return uniq(
      (tacs || []).reduce((pre, i) => {
        const _r = [...pre, ...(i.consentAttributes || [])];
        return _r;
      }, []),
    );
  };

  return (
    <React.Fragment>
      {tcVisible && (
        <TCModals
          tcs={tcsOptions}
          selectedItems={tacs}
          onOk={handleOnTCReselect}
          onCancel={(e) => {
            setTcVisible(false);
          }}
          visible={tcVisible}
        />
      )}

      {fieldsVisible && (
        <FieldModal
          title={getI18n('general.customerinformationfield')}
          visible={fieldsVisible}
          {...selectedField}
          onOk={handleOnFieldOk}
          onCancel={onFieldModalCancel}
          placeholderRequired
        />
      )}

      <Section bottomBorder>
        <ItemWrapper
          title={`${getI18n('general.title')}*`}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            maxLength={100}
            size='large'
            value={title}
            onChange={handleOnTitleChange}
            error={titleErr.length > 0}
            help={titleErr.join(' ')}
          />
        </ItemWrapper>

        <ItemWrapper
          title={`${getI18n('general.upload.EditModal.description')} (${getI18n(
            'general.optional',
          )})`}
          rightPart={
            <CountWords count={(description || '').length} allCount={200} />
          }>
          <TextArea
            maxLength={200}
            value={description}
            onChange={handleOnDesChange}
          />
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('general.backgroundColour')}
          id={`${draggableId}DesBkgColor`}>
          <ColorPicker
            color={backgroundColor}
            onChange={handleOnBkgChange}
            multi
            id={`${draggableId}DesBkgColor`}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('general.textColour')}
          id={`${draggableId}DesTextColor`}>
          <ColorPicker
            color={textColor}
            onChange={handleOnTextColorChange}
            options={['#fff', '#000']}
            id={`${draggableId}DesTextColor`}
          />
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper
          rightPart={<CountWords count={(text || '').length} allCount={16} />}
          title={`${getI18n('general.buttonText')}*`}>
          <Input
            error={btnTitleErr.length > 0}
            help={btnTitleErr.join(' ')}
            maxLength={16}
            size='large'
            value={text}
            placeholder={replaceI18nVariables(
              getI18n('general.fieldisrequired'),
              getI18n('general.buttonText'),
            )}
            onChange={handleOnBtnTextChange}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('general.buttonBackgroundColour')}
          id={`${draggableId}BtnBkgColor`}>
          <ColorPicker
            onChange={handleOnBtnBkgColorChange}
            color={btnBkgColor}
            multi
            id={`${draggableId}BtnBkgColor`}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('general.buttonTextColour')}
          id={`${draggableId}BtnTextColor`}>
          <ColorPicker
            onChange={handleOnBtnTextColorChange}
            color={btnTextColor}
            options={['#fff', '#000']}
            id={`${draggableId}BtnTextColor`}
          />
        </ItemWrapper>
      </Section>

      <DragNDropColumns
        titleRightTextClassName={css.editContainer}
        //displayWarningModalWhenDeleting
        title={getI18n('general.customerInformationFields')}
        titleRightFunction={() => {
          setSelectedField({ availableFields: generateAvailableField() });
          setFieldsVisible(true);
        }}
        titleRightText={getI18n('general.linkModule.Modal.add')}
        childGenerate={fieldChildGenerate}
        onDelete={handleOnFieldDelete}
        data={fields.map((i) => {
          const type = get(i, 'field.fieldType');
          if (unDeletable.includes(type)) {
            return { ...i, hideDelete: true };
          }
          return i;
        })}
        droppableId={`${droppableId}${draggableId}FieldDropArea`}
        onSort={handleOnFieldSort}
        hideAdd
      />
      <DragNDropColumns
        errorInTitle={tcErr.join(' ')}
        subTitle={getI18n('general.addTermsConditions')}
        titleRightTextClassName={css.editContainer}
        //displayWarningModalWhenDeleting
        title={getI18n('general.termsConditions')}
        titleRightFunction={() => {
          setTcVisible(true);
        }}
        titleRightText={getI18n('general.edit')}
        childGenerate={tcChildGenerate}
        onDelete={handleOnTCDelete}
        data={tacs}
        droppableId={`${droppableId}${draggableId}TCDropArea`}
        onSort={handleOnTCSort}
        hideAdd
      />
      <Section className={css.attContainer}>
        <div className={css.title}>{getI18n('general.consentAttribute')}</div>
        {getAllAttributes().map((i: string) => {
          return (
            <Tag className={css.tag} closable={false} key={6}>
              <NoWrapContainer>
                <Tooltip title={i}>{i}</Tooltip>
              </NoWrapContainer>
            </Tag>
          );
        })}
      </Section>
    </React.Fragment>
  );
};
export default ModalHoc(Subscription);
